import React from 'react';

interface LoaderProps {
  size?: number; // Diameter of loader in rem units (default 10rem)
  colors?: [string, string, string]; // Gradient colors
}

const AiGradient: React.FC<LoaderProps> = ({
  size = 10,
  colors = ['#F09A59', '#a541df', '#399fc5'],
}) => {
  const customCss = `
    .loader-container {
      animation: group-rotate 6s ease-in-out infinite alternate;
      width: ${size}rem;
      height: ${size}rem;
      position: relative;
    }
    .blob {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background: linear-gradient(135deg, ${colors[0]} 0%, ${colors[1]} 50%, ${colors[2]} 100%);
      box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.05));
    }
    .blob-core {
      position: absolute;
      width: 65%;
      height: 65%;
      top: 17.5%;
      left: 17.5%;
      border-radius: 50%;
      background: radial-gradient(circle at center, rgba(255,255,255,1) 0%, rgba(255,255,255,0.6) 30%, transparent 70%);
      filter: blur(8px);
      animation: core-pulse 4s ease-in-out infinite alternate;
      z-index: 40;
    }
    .blob-3, .blob-2, .blob-1 {
      opacity: 0.3;
      filter: blur(1px);
    }
    .blob-3 { z-index: 30; animation: blob-wobble-1 4s cubic-bezier(0.42, 0, 0.58, 1) infinite; }
    .blob-2 { z-index: 20; animation: blob-wobble-2 5s cubic-bezier(0.8, 0.2, 0.5, 0.9) infinite; }
    .blob-1 { z-index: 10; animation: blob-wobble-1 4s cubic-bezier(0.42, 0, 0.58, 1) infinite 2s; }
    @keyframes blob-wobble-1 {
      0%, 100% { transform: translate(0,0) rotate(0deg) scale(1); }
      25% { transform: translate(-10px,5px) rotate(5deg) scale(1.05); }
      50% { transform: translate(0,10px) rotate(-5deg) scale(0.95); }
      75% { transform: translate(10px,-5px) rotate(0deg) scale(1.02); }
    }
    @keyframes blob-wobble-2 {
      0%, 100% { transform: translate(0,0) rotate(0deg) scale(1); }
      33% { transform: translate(5px,15px) rotate(3deg) scale(1.03); }
      66% { transform: translate(-15px,-5px) rotate(-7deg) scale(0.98); }
    }
    @keyframes core-pulse {
      0%, 100% { transform: scale(1); opacity: 0.8; }
      50% { transform: scale(1.05); opacity: 0.9; }
    }
    @keyframes group-rotate {
      0%, 100% { transform: rotate(0deg); }
      50% { transform: rotate(5deg); }
    }
  `;

  
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <style>{customCss}</style>
      <div className="loader-container" role="status" aria-label="Loading">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
        <div className="blob-core"></div>
      </div>
    </div>
  );
};
export default AiGradient;